import AdminsBox from './AdminsBox';
import AdminsBoxContainer from './AdminsBox.container';

export default AdminsBoxContainer(AdminsBox);
